import { render } from "./BellIcon.vue?vue&type=template&id=4e3de3bd&scoped=true"
import script from "./BellIcon.vue?vue&type=script&lang=js"
export * from "./BellIcon.vue?vue&type=script&lang=js"

import "./BellIcon.vue?vue&type=style&index=0&id=4e3de3bd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e3de3bd"

export default script